import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workDocsWorkAreaGrid: [],
    workDocsWorkAreaGrid_project: [],
    workDocsWorkAreaAll: [],
    workDocsWorkAreaShow: null,
    pageData: null,
  },
  mutations: {
    setWorkDocsWorkAreaGrid(state, payload) {
      state.workDocsWorkAreaGrid = payload
    },
    setWorkDocsWorkAreaGrid_project(state, payload) {
      state.workDocsWorkAreaGrid_project = payload
    },
    setWorkDocsWorkAreaAll(state, payload) {
      state.workDocsWorkAreaAll = payload
    },
    setWorkDocsWorkAreaShow(state, payload) {
      state.workDocsWorkAreaShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workDocsWorkAreaGrid: (state) => {
      return state.workDocsWorkAreaGrid
    },
    workDocsWorkAreaGrid_project: (state) => {
      return state.workDocsWorkAreaGrid_project
    },
    workDocsWorkAreaAll: (state) => {
      return state.workDocsWorkAreaAll
    },
    workDocsWorkAreaShow: (state) => {
      return state.workDocsWorkAreaShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkDocsWorkAreaGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/work/work-area/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsWorkAreaGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkDocsWorkAreaGrid_project(
      { commit, rootState },
      { limit, page, project_id, sort, search },
    ) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain +
        '/api/admin/work/work-area/grid?limit=' +
        limit +
        '&page=' +
        page +
        '&filter[]=project_id:' +
        project_id
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsWorkAreaGrid_project', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkDocsWorkAreaAll({ commit, rootState }, project_id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/work-area/grid?limit=0&filter[]=project_id:' +
            project_id +
            '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsWorkAreaAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsWorkAreaShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/work-area/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkDocsWorkAreaShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsWorkAreaCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/work-area',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsWorkAreaUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/work-area',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkDocsWorkAreaDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/work-area/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
